module.exports = __webpack_public_path__ + "media/images/lb/182-67831b02f7d38329ad4ce8f30ac46050.svg";